import { forwardRef } from 'react';

import { IconProps } from '.';

export const ArrowLongDownIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M10.4092 16.9792L15.2092 12.1892C15.3234 12.0732 15.3874 11.917 15.3874 11.7542C15.3874 11.5914 15.3234 11.4352 15.2092 11.3192L14.4792 10.5992C14.362 10.4873 14.2063 10.4249 14.0442 10.4249C13.8822 10.4249 13.7264 10.4873 13.6092 10.5992L11.0992 13.0692L11.0992 3.58922C11.0966 3.39111 11.0168 3.20185 10.8767 3.06175C10.7366 2.92166 10.5473 2.84181 10.3492 2.83922L9.60924 2.83922C9.41113 2.84181 9.22186 2.92166 9.08177 3.06175C8.94168 3.20185 8.86183 3.39111 8.85924 3.58922L8.85924 13.0692L6.34924 10.5592C6.23204 10.4473 6.07625 10.3849 5.91424 10.3849C5.75222 10.3849 5.59643 10.4473 5.47924 10.5592L4.74924 11.2792C4.63503 11.3952 4.57102 11.5514 4.57102 11.7142C4.57102 11.877 4.63503 12.0332 4.74924 12.1492L9.54924 16.9792C9.60515 17.0367 9.672 17.0823 9.74586 17.1135C9.81971 17.1447 9.89907 17.1608 9.97924 17.1608C10.0594 17.1608 10.1388 17.1447 10.2126 17.1135C10.2865 17.0823 10.3533 17.0367 10.4092 16.9792Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ArrowLongDownIcon;
